/** True when an experience has a headline price to show — i.e. pricing is
 *  configured. The public DTO returns `priceFrom = null` for an unpriced
 *  experience (zero packages) and a real `{ amount: 0 }` only for a genuinely
 *  FREE one. So presence — not `amount > 0` — is the correct gate: a free tour
 *  should still show its price and stay bookable; only an unpriced one reads as
 *  "Pricing coming soon". This is the single predicate every price surface
 *  (cards, sticky bar, structured data) shares so they can't drift apart. */
export function hasDisplayPrice(
  price: { amount: number; currencyCode: string } | null | undefined,
): price is { amount: number; currencyCode: string } {
  return price != null;
}
